<template>
	<div>
		<case-form :schema="schema" class="mt6" />
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
export default {
	components: {
		CaseForm
	},

	computed: {
		schema() {
			return [
				{
					label:
						"Are you a politician, government official, member of any uniformed forces, labor union, member of the judiciary, missionary or a journalist?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isPEP`,
					props: {
						suggest: {
							typeIncludes: `isPEP`
						},
						createOptions: {
							type: `isPEP`,
							dataType: "boolean"
						}
					}
				},
				{
					component: "html",
					props: {
						content:
							'<div class="xs-12 fs4 fw7 mb2 mt6">If yes, please provide details</div>'
					}
				},
				{
					label: "Title",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPTitle`,
					props: {
						suggest: {
							typeIncludes: `PEPTitle`
						},
						createOptions: {
							type: `PEPTitle`,
							dataType: "string"
						}
					}
				},
				{
					label: "Rank",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPRank`,
					props: {
						suggest: {
							typeIncludes: `PEPRank`
						},
						createOptions: {
							type: `PEPRank`,
							dataType: "string"
						}
					}
				},
				{
					label: "Duties",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0PEPDuties`,
					props: {
						suggest: {
							typeIncludes: `PEPDuties`
						},
						createOptions: {
							type: `PEPDuties`,
							dataType: "string"
						}
					}
				},
				{
					label: "If no, what is your occupation?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0occupation`,
					props: {
						suggest: {
							typeIncludes: `occupation`
						},
						createOptions: {
							type: `occupation`,
							dataType: "string"
						}
					}
				},
				{
					label: `Do you exercise on a regular basis?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasRegularExercise`,
					props: {
						suggest: {
							typeIncludes: `hasRegularExercise`
						},
						createOptions: {
							type: `hasRegularExercise`,
							dataType: "boolean"
						}
					}
				},
				{
					component: "html",
					props: {
						content:
							'<div class="xs-12 fs4 fw7 mb2 mt6">If yes, please provide details</div>'
					}
				},
				{
					label: "Type",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0exerciseType`,
					props: {
						suggest: {
							typeIncludes: `exerciseType`
						},
						createOptions: {
							type: `exerciseType`,
							dataType: "string"
						}
					}
				},
				{
					label: "Frequency",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0exerciseFrequency`,
					props: {
						suggest: {
							typeIncludes: `exerciseFrequency`
						},
						createOptions: {
							type: `exerciseFrequency`,
							dataType: "string"
						}
					}
				},
				{
					label: "Duration",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0exerciseDuration`,
					props: {
						suggest: {
							typeIncludes: `exerciseDuration`
						},
						createOptions: {
							type: `exerciseDuration`,
							dataType: "string"
						}
					}
				},
				{
					label: `Do you participate in hazardous avocations such as scuba diving, hang gliding, mountain climbing,
automobile racing or other hazardous activity?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0participateInHazardousAvocation`,
					props: {
						suggest: {
							typeIncludes: `participateInHazardousAvocation`
						},
						createOptions: {
							type: `participateInHazardousAvocation`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Do you participate in aviation activities other than as a passenger on scheduled commercial airlines?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0participateInAviationActivities`,
					props: {
						suggest: {
							typeIncludes: `participateInAviationActivities`
						},
						createOptions: {
							type: `participateInAviationActivities`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "Do you drive after using alcoholic beverages?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasDrinkAndDrive`,
					props: {
						suggest: {
							typeIncludes: `hasDrinkAndDrive`
						},
						createOptions: {
							type: `hasDrinkAndDrive`,
							dataType: "boolean"
						}
					}
				},
				{
					component: "html",
					props: {
						content:
							'<div class="xs-12 fs4 fw7 mb2 mt6">If yes, please provide details</div>'
					}
				},
				{
					label: "Date",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0drinkAndDriveDate`,
					props: {
						suggest: {
							typeIncludes: `drinkAndDriveDate`
						},
						createOptions: {
							type: `drinkAndDriveDate`,
							dataType: "date"
						}
					}
				},
				{
					label: "Country",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0drinkAndDriveCountry`,
					props: {
						suggest: {
							typeIncludes: `drinkAndDriveCountry`
						},
						createOptions: {
							type: `drinkAndDriveCountry`,
							dataType: "string"
						}
					}
				},
				{
					label: "Details",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0drinkAndDriveDetails`,
					props: {
						suggest: {
							typeIncludes: `drinkAndDriveDetail`
						},
						createOptions: {
							type: `drinkAndDriveDetail`,
							dataType: "string"
						}
					}
				},
				{
					label:
						"Have you ever been stopped for speeding, an improper turn, failure to stop at a light or any other moving violation?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasMovingViolation`,
					props: {
						suggest: {
							typeIncludes: `hasMovingViolation`
						},
						createOptions: {
							type: `hasMovingViolation`,
							dataType: "boolean"
						}
					}
				},
				{
					component: "html",
					props: {
						content:
							'<div class="xs-12 fs4 fw7 mb2 mt6">If yes, please provide details</div>'
					}
				},
				{
					label: "Date",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0movingViolationDate`,
					props: {
						suggest: {
							typeIncludes: `movingViolationDate`
						},
						createOptions: {
							type: `movingViolationDate`,
							dataType: "date"
						}
					}
				},
				{
					label: "Country",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0movingViolationCountry`,
					props: {
						suggest: {
							typeIncludes: `movingViolationCountry`
						},
						createOptions: {
							type: `movingViolationCountry`,
							dataType: "string"
						}
					}
				},
				{
					label: "Details",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0movingViolationDetails`,
					props: {
						suggest: {
							typeIncludes: `movingViolationDetails`
						},
						createOptions: {
							type: `movingViolationDetails`,
							dataType: "string"
						}
					}
				},
				{
					label:
						"Have you ever been charged with driving while intoxicated or while otherwise impaired?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasDrivingUnderInfluenceCharge`,
					props: {
						suggest: {
							typeIncludes: `hasDrivingUnderInfluenceCharge`
						},
						createOptions: {
							type: `hasDrivingUnderInfluenceCharge`,
							dataType: "boolean"
						}
					}
				},
				{
					component: "html",
					props: {
						content:
							'<div class="xs-12 fs4 fw7 mb2 mt6">If yes, please provide details</div>'
					}
				},
				{
					label: "Date",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0drivingUnderInfluenceDate`,
					props: {
						suggest: {
							typeIncludes: `drivingUnderInfluenceDate`
						},
						createOptions: {
							type: `drivingUnderInfluenceDate`,
							dataType: "date"
						}
					}
				},
				{
					label: "Country",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0drivingUnderInfluenceCountry`,
					props: {
						suggest: {
							typeIncludes: `drivingUnderInfluenceCountry`
						},
						createOptions: {
							type: `drivingUnderInfluenceCountry`,
							dataType: "string"
						}
					}
				},
				{
					label: "Details",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0drivingUnderInfluenceDetails`,
					props: {
						suggest: {
							typeIncludes: `drivingUnderInfluenceDetails`
						},
						createOptions: {
							type: `drivingUnderInfluenceDetails`,
							dataType: "string"
						}
					}
				},
				{
					label:
						"Have you ever been charged due to a motor vehicle accident or had your driver’s license suspended?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasMotorAccidentOrLicenseSuspended`,
					props: {
						suggest: {
							typeIncludes: `hasMotorAccidentOrLicenseSuspended`
						},
						createOptions: {
							type: `hasMotorAccidentOrLicenseSuspended`,
							dataType: "boolean"
						}
					}
				},
				{
					component: "html",
					props: {
						content:
							'<div class="xs-12 fs4 fw7 mb2 mt6">If yes, please provide details</div>'
					}
				},
				{
					label: "Date",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0motorAccidentDate`,
					props: {
						suggest: {
							typeIncludes: `motorAccidentDate`
						},
						createOptions: {
							type: `motorAccidentDate`,
							dataType: "date"
						}
					}
				},
				{
					label: "Country",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0motorAccidentCountry`,
					props: {
						suggest: {
							typeIncludes: `motorAccidentCountry`
						},
						createOptions: {
							type: `motorAccidentCountry`,
							dataType: "string"
						}
					}
				},
				{
					label: "Details",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0motorAccidentDetails`,
					props: {
						suggest: {
							typeIncludes: `motorAccidentDetails`
						},
						createOptions: {
							type: `motorAccidentDetails`,
							dataType: "string"
						}
					}
				},
				{
					label: `Have you ever been convicted of a criminal offense?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasBeenConvicted`,
					props: {
						suggest: {
							typeIncludes: `hasBeenConvicted`
						},
						createOptions: {
							type: `hasBeenConvicted`,
							dataType: "boolean"
						}
					}
				},
				{
					component: "html",
					props: {
						content:
							'<div class="xs-12 fs4 fw7 mb2 mt6">If yes, please provide details</div>'
					}
				},
				{
					label: "Date",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0convictionDate`,
					props: {
						suggest: {
							typeIncludes: `convictionDate`
						},
						createOptions: {
							type: `convictionDate`,
							dataType: "date"
						}
					}
				},
				{
					label: "Country",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0convictionCountry`,
					props: {
						suggest: {
							typeIncludes: `convictionCountry`
						},
						createOptions: {
							type: `convictionCountry`,
							dataType: "string"
						}
					}
				},
				{
					label: "Details",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0convictionDetails`,
					props: {
						suggest: {
							typeIncludes: `convictionDetails`
						},
						createOptions: {
							type: `convictionDetails`,
							dataType: "string"
						}
					}
				},
				{
					label: `In the past 10 years, have you been convicted of reckless driving, driving while intoxicated, or had a driving
license suspended or revoked?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasBeenConvictedOfRecklessDrivingInPast10Years`,
					props: {
						suggest: {
							typeIncludes: `hasBeenConvictedOfRecklessDrivingInPast10Years`
						},
						createOptions: {
							type: `hasBeenConvictedOfRecklessDrivingInPast10Years`,
							dataType: "boolean"
						}
					}
				},
				{
					component: "html",
					props: {
						content:
							'<div class="xs-12 fs4 fw7 mb2 mt6">If yes, please provide details</div>'
					}
				},
				{
					label: "Date",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0recklessDrivingDate`,
					props: {
						suggest: {
							typeIncludes: `recklessDrivingDate`
						},
						createOptions: {
							type: `recklessDrivingDate`,
							dataType: "date"
						}
					}
				},
				{
					label: "Country",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0recklessDrivingCountry`,
					props: {
						suggest: {
							typeIncludes: `recklessDrivingCountry`
						},
						createOptions: {
							type: `recklessDrivingCountry`,
							dataType: "string"
						}
					}
				},
				{
					label: "Details",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0recklessDrivingDetails`,
					props: {
						suggest: {
							typeIncludes: `recklessDrivingDetails`
						},
						createOptions: {
							type: `recklessDrivingDetails`,
							dataType: "string"
						}
					}
				},
				{
					label: `Have you ever been convicted due to an automobile accident?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasBeenConvictedOfAutoMobileAccident`,
					props: {
						suggest: {
							typeIncludes: `hasBeenConvictedOfAutoMobileAccident`
						},
						createOptions: {
							type: `hasBeenConvictedOfAutoMobileAccident`,
							dataType: "boolean"
						}
					}
				},
				{
					component: "html",
					props: {
						content:
							'<div class="xs-12 fs4 fw7 mb2 mt6">If yes, please provide details</div>'
					}
				},
				{
					label: "Date",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0automobileAccidentDate`,
					props: {
						suggest: {
							typeIncludes: `automobileAccidentDate`
						},
						createOptions: {
							type: `automobileAccidentDate`,
							dataType: "date"
						}
					}
				},
				{
					label: "Country",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0automobileAccidentCountry`,
					props: {
						suggest: {
							typeIncludes: `automobileAccidentCountry`
						},
						createOptions: {
							type: `automobileAccidentCountry`,
							dataType: "string"
						}
					}
				},
				{
					label: "Details",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0automobileAccidentDetails`,
					props: {
						suggest: {
							typeIncludes: `automobileAccidentDetails`
						},
						createOptions: {
							type: `automobileAccidentDetails`,
							dataType: "string"
						}
					}
				},
				{
					label: `Do you have any pending charges, or have you ever been charged with or convicted of any criminal offense,
or are you currently on probation, parole or statutory release?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasPendingChargesOrCriminalHistory`,
					props: {
						suggest: {
							typeIncludes: `hasPendingChargesOrCriminalHistory`
						},
						createOptions: {
							type: `hasPendingChargesOrCriminalHistory`,
							dataType: "boolean"
						}
					}
				},
				{
					component: "html",
					props: {
						content:
							'<div class="xs-12 fs4 fw7 mb2 mt6">If yes, please provide details</div>'
					}
				},
				{
					label: "Date",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0pendingChargesDate`,
					props: {
						suggest: {
							typeIncludes: `pendingChargesDate`
						},
						createOptions: {
							type: `pendingChargesDate`,
							dataType: "date"
						}
					}
				},
				{
					label: "Country",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0pendingChargesCountry`,
					props: {
						suggest: {
							typeIncludes: `pendingChargesCountry`
						},
						createOptions: {
							type: `pendingChargesCountry`,
							dataType: "string"
						}
					}
				},
				{
					label: "Details",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0pendingChargesDetails`,
					props: {
						suggest: {
							typeIncludes: `pendingChargesDetails`
						},
						createOptions: {
							type: `pendingChargesDetails`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
